module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "zoomer"
  }, [_c('div', {
    staticClass: "zoomer-slide"
  }, [_c('b-carousel', {
    attrs: {
      "id": "carousel1",
      "controls": "",
      "label-prev": "",
      "label-next": "",
      "background": "white",
      "interval": 0
    },
    on: {
      "sliding-start": _vm.onSlideStart,
      "sliding-end": _vm.onSlideEnd
    },
    model: {
      value: (_vm.slide),
      callback: function($$v) {
        _vm.slide = $$v
      },
      expression: "slide"
    }
  }, _vm._l((_vm.getFigures()), function(figure, key) {
    return _c('b-carousel-slide', {
      key: key
    }, [_c('img', {
      staticClass: "d-block img-fluid w-100",
      staticStyle: {
        "margin": "0 auto",
        "max-height": "100vh"
      },
      attrs: {
        "id": _vm.action.idImg,
        "width": "auto",
        "src": _vm.baseUrl + figure.big
      },
      slot: "img"
    })])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f3bb7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/actions/Zoomer.vue
// module id = 3222
// module chunks = 0